import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_SPECIAL_CHARS = '!@#$%^&*';
export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordPolicyChecks {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  isValid: boolean;
}

export function getPasswordPolicyChecks(password: string): PasswordPolicyChecks {
  const value = password ?? '';
  const hasMinLength = value.length >= PASSWORD_MIN_LENGTH;
  const hasUppercase = /[A-Z]/.test(value);
  const hasLowercase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!@#$%^&*]/.test(value);

  return {
    hasMinLength,
    hasUppercase,
    hasLowercase,
    hasNumber,
    hasSpecialChar,
    isValid: hasMinLength && hasUppercase && hasLowercase && hasNumber && hasSpecialChar,
  };
}

export function passwordPolicyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return getPasswordPolicyChecks(String(control.value)).isValid ? null : { passwordPolicy: true };
  };
}
